// Common Next.js Sentry configs for server, client and edge
export const commonConfig = {
    dsn: "https://f653ed76ef0815d70b57f6c58a0bc66f@o4510220176588800.ingest.de.sentry.io/4510303216074832",

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,

    // Enable logs to be sent to Sentry
    _experiments: {
        enableLogs: true,
    },

    // TODO: Set environment
}